export default {"src":"/_next/static/media/stethoscope.7efd62c3.svg","height":100,"width":100};